module.exports = __webpack_public_path__ + "img/PCI_DSS_Validated.6d21a8c.webp";